import React from 'react';
import './index.scss';

const BetaTag: React.FC = () => {
  return <p className="beta_tag">(Beta)</p>;
};

export default BetaTag;
